import constants from '@/utils/constants';

function dealWithAnalyticToolsDuePolicy(consentCookie) {
  const canUseAnalyticTools = consentCookie.analyticsCookies;
  window[`ga-disable-${constants.GA_MEASUREMENT_ID}`] = !canUseAnalyticTools;
}

function dummy() {}

export {
  dealWithAnalyticToolsDuePolicy,
  dummy,
};
